import { QueryType } from '../apollo/graphqlSchema';
import { IPredictionAnalysis } from '../apollo/responseTypes';
import {
  IPredictionCorrelationData,
  IParsedChartDataPrediction,
} from '../../components/Chart/interfaces';
import { assertNotNil } from '../types';

export default (analysis: IPredictionAnalysis): IParsedChartDataPrediction => {
  assertNotNil(analysis.data);
  const correlationData: Record<string, IPredictionCorrelationData[]> = {};
  const { correlationKinds, events, eventCorrelations } = analysis.data;
  // event level
  for (const eventCorrelation of eventCorrelations) {
    // event row value
    const eventDayCorrelations = eventCorrelation.eventDayCorrelations.map(
      (eventDayCorrelation, columnIndex: number) => {
        const strongestValues: any = {};
        const eventFrequencyCorrelations =
          eventDayCorrelation.frequencyCorrelations.map(
            (frequencyCorrelation: any, index: number) => {
              const { correlation, userStatus, contingency } =
                frequencyCorrelation;
              if (
                index === eventDayCorrelation.strongestEventFrequencyCorrelation
              ) {
                for (const kind of correlationKinds) {
                  strongestValues[kind.key] = correlation[kind.key];
                }
              }
              return {
                frequencyDay: index + 1,
                ...correlation,
                ...contingency,
                ...userStatus,
              };
            },
          );

        // generate prediction chart data
        const predictionChartData: any = {};
        for (const kind of correlationKinds) {
          predictionChartData[kind.key] = eventFrequencyCorrelations.map(
            (frequencyCorrelation: any) => {
              return {
                name: `\u2265 ${frequencyCorrelation.frequencyDay}`,
                [kind.key]: frequencyCorrelation[kind.key],
              };
            },
          );
        }

        return {
          strongestFrequencyIndex:
            eventDayCorrelation?.strongestEventFrequencyCorrelation,
          strongestValues: { ...strongestValues },
          predictionChartData: { ...predictionChartData },
          eventFrequencyCorrelations,
          columnIndex,
        };
      },
    );
    correlationData[eventCorrelation.event] = eventDayCorrelations;
  }
  return {
    queryType: QueryType.Prediction,
    data: {
      correlationKinds,
      events,
      selectedValue: correlationKinds?.[0]?.key,
      correlationData,
    },
  };
};
